import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { GetChatHistoryModel } from 'src/app/chat/models/get-chat-history.model';
import { CustomValidators } from 'src/app/providers/CustomValidator';
import { ToastService } from 'src/app/services/toast/toast.service';
import { VerifyEmailRequest } from 'src/app/_models/Authentication/verify-email-request';
import { ApiService } from 'src/app/_services/api.service';
import { AuthService } from 'src/app/_services/auth.service';
import { TokenStorageService } from 'src/app/_services/token-storage.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
 
  changePasswordForm: UntypedFormGroup = new UntypedFormGroup({});
  loadingPage = false;
  spinner = false;
  forgotEmailToken = '';
  verifyEmailToken = '';
  constructor(    
    private apiService: ApiService,
    private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private tokenStorage: TokenStorageService,
  ) {
    this.route.queryParams.subscribe(params => {    
      //here
      if(params['confirmation_token']){
        this.forgotEmailToken = params['confirmation_token'];
      } else if(params['verify_token']){
        this.verifyEmailToken = params['verify_token'];
      }
    });
  }

  ngOnInit(): void {
    if(this.forgotEmailToken != ''){
      this.initLoginForm();
    } else if(this.verifyEmailToken != ''){
      this.verifyEmail(this.verifyEmailToken);
    }
  }

  private initLoginForm(): void {
    this.changePasswordForm = new UntypedFormGroup(
      {
        password: new UntypedFormControl('', [Validators.required, Validators.minLength(6),
        Validators.pattern('^(?=[^A-Z]*[A-Z])(?=[^a-z]*[a-z])(?=\\D*\\d)[A-Za-z\\d!$%@#£€*?&.,]{8,}$')]),
        confirmPassword: new UntypedFormControl('', [Validators.required]),       
        languageId: new UntypedFormControl(0, [Validators.required]),
      },
      //@ts-ignore
      CustomValidators.mustMatch('password', 'confirmPassword')
    );
  }

  onChangePassowrdFormSubmit(): void {
    if (this.changePasswordForm.invalid) {
      return;
    }
    this.loadingPage = true;
    let data = this.changePasswordForm.value;
    let languageId = localStorage.getItem('languageId');
    if (languageId != null) {
      data.languageId = parseInt(languageId);
    }
    data.forgotEmailToken = this.forgotEmailToken;
    this.apiService.confirmpassword(data).subscribe((response) => {
      if (response) {
        this.loadingPage = false;
        this.authService._isLoggedIn$.next(true);
        this.tokenStorage.saveToken(response.jwtToken);
        this.authService.handleAuthentication();
        this.authService._isSuperAdmin$.next(false);
        this.authService._isAdvertiser$.next(true);
        this.router.navigate(['./promoter']);
      }
    },(error)=>{
      this.loadingPage = false;
      // this.router.navigate(['./login']);
    });
  }

  verifyEmail(verifyToken:string){
    this.spinner = true;
    let languageId = localStorage.getItem('languageId');
    const verifyEmailRequest = new VerifyEmailRequest();
    verifyEmailRequest.verificationToken = verifyToken;
    if (languageId != null) {
      verifyEmailRequest.languageId = parseInt(languageId);
    }
    this.apiService.verifyemail(verifyEmailRequest).subscribe((response) => {
      if(response){
        this.spinner = false;
        //no jwt token in the response
        // this.authService._isLoggedIn$.next(true);
        // this.tokenStorage.saveToken(response.jwtToken);        
        // this.authService.handleAuthentication();
        this.authService._isSuperAdmin$.next(false);
        this.authService._isAdvertiser$.next(true);
        this.router.navigate(['./promoter']);
      }
    },(error)=>{
      this.spinner = false;
      this.router.navigate(['./login']);
    });
  }

  get changePasswordFormControls() {
    return this.changePasswordForm.controls;
  }
}
